import { Component } from "react";
import PropTypes from "prop-types";

/**
 * @param   {Boolean} firstInitial
 * @param   {Number}  suggestionsCount
 * @returns {Number}
 */
function getSafeInitialSelectedIndex(firstInitial, suggestionsCount) {
  if (firstInitial) {
    return suggestionsCount > 0 ? 0 : -1;
  } else {
    return -1;
  }
}

export default class SelectedSuggestionIndex extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
    firstInitial: PropTypes.bool,
    suggestionsCount: PropTypes.number.isRequired,
  };

  static defaultProps = {
    firstInitial: false,
  };

  state = {
    selectedSuggestionIndex: getSafeInitialSelectedIndex(
      this.props.firstInitial,
      this.props.suggestionsCount,
    ),
  };

  componentWillReceiveProps(nextProps) {
    const { firstInitial, suggestionsCount } = nextProps;

    if (firstInitial) {
      this.setState({
        selectedSuggestionIndex: suggestionsCount > 0 ? 0 : -1,
      });
    } else {
      this.setState({
        selectedSuggestionIndex: -1,
      });
    }
  }

  normalizeSelectedIndex = (selectedIndex, suggestionsCount) => {
    const potentialIndex = selectedIndex % suggestionsCount;
    return potentialIndex < 0 ? suggestionsCount - 1 : potentialIndex;
  };

  moveToSelectedIndex = nextSelectedIndex => {
    const { suggestionsCount } = this.props;

    this.setState({
      selectedSuggestionIndex: this.normalizeSelectedIndex(
        nextSelectedIndex,
        suggestionsCount,
      ),
    });
  };

  /**
   * @param {SyntheticKeyboardEvent}
   */
  handleMoveToNextSuggestion = event => {
    event.preventDefault();

    const { selectedSuggestionIndex } = this.state;
    this.moveToSelectedIndex(selectedSuggestionIndex + 1);
  };

  /**
   * @param {SyntheticKeyboardEvent}
   */
  handleMoveToPreviousSuggestion = event => {
    event.preventDefault();

    const { selectedSuggestionIndex } = this.state;
    this.moveToSelectedIndex(selectedSuggestionIndex - 1);
  };

  render() {
    const { selectedSuggestionIndex } = this.state;
    const { children } = this.props;

    return children({
      selectedSuggestionIndex,
      moveToPreviousSuggestion: this.handleMoveToPreviousSuggestion,
      moveToNextSuggestion: this.handleMoveToNextSuggestion,
    });
  }
}
